import React, { useEffect } from 'react';
import { Button, Result } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { routesPath } from '../../common/constants/routesPath';
import { Flex } from 'antd';

function ErrorPage() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!location.state) {
            navigate(routesPath.ROOT.DASHBOARD);
        }
    }, [location, navigate]);

    function handleNavigation() {
        if (window.history.length > 2) {
            navigate(-1);
        } else {
            navigate(routesPath.ROOT.DASHBOARD);
        }
    }

    return (
        <Flex
            justify="center"
            align="center"
            style={{
                minHeight: '100vh',
                width: '100%',
            }}
        >
            <Result
                status={location.state?.status}
                title={location.state?.title}
                subTitle={location.state?.subTitle}
                extra={
                    <Button
                        onClick={handleNavigation}
                        type="primary"
                        size="large"
                        style={{
                            height: '48px',
                            padding: '0 48px',
                            fontSize: '16px',
                            fontWeight: 500,
                            borderRadius: '6px',
                            boxShadow: '0 2px 0 rgba(0, 0, 0, 0.045)',
                        }}
                    >
                        Go Back
                    </Button>
                }
            />
        </Flex>
    );
}

export default ErrorPage;
